import Layout from '@/layouts/EmptyLayout'
export default [{
    path: '/complaintTable',
    name: 'complaintTable',
    meta: {
      layout: 'main'
    },
  component: () => import('@/views/complaintTable/index')
    
  }]
